<template>
    <div class="main-app-container">
        <div class="app-page-container">
            <Headers/>
            <Sidebar v-if="!isHidden"/>

            <div class="app-content-wrapper">
                <div :class="isHidden ? 'app-content-full' : 'app-content'">
                    <div class="full-height">
                        <div :class="isHidden ? 'container-full' : 'container'">
                            <transition name="fade">
                                    <router-view :key="$route.fullPath"/>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Headers from '@/components/Headers/Headers'
    import Sidebar from '@/components/Sidebar'
    import { bus } from '@/Bus'

    export default {
        name: 'dashboard',
        components: {
            Headers,
            Sidebar
        },
        data () {
            return {
                isHidden: false
            }
        },
        computed: {
            ...mapGetters({
                token: 'getAuthToken',
                user: 'getCurrentUser'
            }),
        },
        watch: {
            user (data) {
                this.user.roles[0].name === 'provider' ? this.isHidden = true : this.isHidden = false
            }
        },
        created () {
            bus.$on('provider-log', ()=> {                
                this.isHidden = true
            });
            if (this.token && this.user) {         
                this.user.roles[0].name === 'provider' ? this.isHidden = true : this.isHidden = false
            }
        }
    }
</script>

<style scoped>
    .main-app-container,
    .app-page-container {
        height: 100%;
    }

    .app-page-container,
    .app-content-wrapper,
    .app-content {
        min-height: 100%;
    }

    .app-content {
        padding-top: 60px;
    }

    .contentBox {
        padding: 10px;
    }

    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    .app-content-wrapper {
        min-height: 100%;
        position: relative;
    }

    .container {
        height: 100%;
        padding: 1em 30px 1em 30px;
    }

    .container-full {
        padding: 30px;
        padding-top: 5em;
    }
    
    .app-content-full {
        padding: 15px;
    }

    @media only screen and (min-width: 1000px) {
        .app-content {
            padding-left: 190px;
        }
    }
    @media only screen and (min-width: 320px) and (max-width: 999px) {
        .app-content {
            padding-left: 64px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue